import { Component, OnInit } from '@angular/core';
  import { FormBuilder, FormGroup, Validators } from '@angular/forms';
  import { Router } from '@angular/router';
  import { AuthService } from 'src/app/services/auth/auth.service';
  import { StorageService } from 'src/app/services/storage/storage.service';
  import { UtilsService } from 'src/app/services/utils/utils.service';
  import { AuthGuardGuard } from 'src/app/services/auth-guard/auth-guard.guard';
  import { HttpClient } from '@angular/common/http';
  // import { ColourService } from 'src/app/services/colour.service';
  import { ActivatedRoute } from '@angular/router';
import { stringify } from 'querystring';

  @Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss']
  })
  export class SigninComponent implements OnInit {
    showOtpBox: boolean = false;
    submitted: boolean = false;
    loginbox: boolean = true;


    inputValue: string = '';
    inputValue1: string = '';
    outputValue: string = '';
    extraTemplate: any;
    userType:string='';


    onInputChange() {
      this.outputValue = this.inputValue;
    }

    onInputChange1() {
      this.outputValue = this.inputValue1;
    }

    validateForm!: FormGroup;
    otpform!: FormGroup;
    constructor(
      private fb: FormBuilder,
      private AuthGuardGuard: AuthGuardGuard,
      private AuthService: AuthService,
      private storageService: StorageService,
      private router: Router,
      private utils:UtilsService
    ) { 

     
}

    


    submitForm(): void {
      if (this.validateForm.valid) {
        // if(this.inputValue.match(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)){
        // this.userType = 'userName'
        // }else{
        //   this.userType = 'userName'
        // }
        this.AuthService.signIn({ ...this.validateForm.value}).subscribe(data => {
          console.log("signIn",data);
          if (data.success === true) {
          const role = data.user?.ngUserRole?.[0]?.userRole==='CLIENT'? 'web':  data.user?.ngUserRole?.[0]?.userRole || data.userType;
          sessionStorage.setItem('role', role);
          sessionStorage.setItem('username', data.user.userName);
          localStorage.setItem('role', role);
          localStorage.setItem('accessToken', data.token);
          localStorage.setItem('userData', JSON.stringify(data.user));
          
          sessionStorage.setItem('logoUrl', data.logoUrl); // Access logoUrl from data object
          console.log('Logo URL stored:', data.logoUrl);
            this.router.navigateByUrl('/dashboard');
            if (data.otpRequired) {
              alert('OTP GENERATED SUCCESSFULLY');
              this.loginbox = false;
              this.showOtpBox = true;
            } else {
            }
          } else {
            this.utils.showErrorMsg(data.message)
            sessionStorage.clear()
            // alert('OTP GENERATION FAILED');
          }
        });
      } else {
        Object.values(this.validateForm.controls).forEach(control => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        });
      }
    }



    getSession(): boolean {
      let token = this.storageService.accessToken;
      return token ? true : false;
    }

    clearCookies(): void {
      // Set the expiry date of the cookies to the past to delete them
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    }

    
    ngOnInit(): void {
      const fullUrl = window.location.href;
      console.log('Full URL:', fullUrl);

      let paramString = '';
      if (fullUrl.includes('userName=')) {
        const url = new URL(fullUrl);
        // If the parameters are in the pathname (e.g., http://localhost:4200/userName=...)
        if (url.pathname.includes('userName=')) {
          paramString = url.pathname.startsWith('/') ? url.pathname.substring(1) : url.pathname;
        } 
        // If the parameters are in the hash (e.g., http://localhost:4200/#/userName=...)
        else if (url.hash.includes('userName=')) {
          paramString = url.hash.includes('?') ? url.hash.split('?')[1] : url.hash;
          if (paramString.startsWith('#')) paramString = paramString.substring(1);
          if (paramString.startsWith('/')) paramString = paramString.substring(1);
        }
        // If the parameters are in standard query string (e.g., http://localhost:4200/?userName=...)
        else if (url.search.includes('userName=')) {
          paramString = url.search.startsWith('?') ? url.search.substring(1) : url.search;
        }

        if (paramString) {
          const params = new URLSearchParams(paramString);
          const userName = params.get('userName');
          const token = params.get('token');

          if (userName && token) {
            console.log('Parsed userName:', userName);
            console.log('Parsed token:', token);
            
            this.AuthService.signurl(userName, token).subscribe(data => {
        console.log(data);
        if (data.success === true) {
          // setTimeout(() => {
          //   window.location.reload();
          // }, 500);
          const role = data.user?.ngUserRole?.[0]?.userRole === 'CLIENT' ? 'web' : data.user?.ngUserRole?.[0]?.userRole || data.userType;
          sessionStorage.setItem('role', role);
          sessionStorage.setItem('username', data.user.userName);
          localStorage.setItem('role', role);
          localStorage.setItem('accessToken', data.token);
          localStorage.setItem('userData', JSON.stringify(data.user));
          
          if (data.logoUrl) {
            sessionStorage.setItem('logoUrl', data.logoUrl);
          } else if (data.data && data.data.logoUrl) {
            sessionStorage.setItem('logoUrl', data.data.logoUrl);
          }

          if (data.userName) {
            sessionStorage.setItem('userName', data.userName);
          }

          console.log('Logo URL stored:', data.logoUrl);
          this.router.navigateByUrl('/dashboard');
          if (data.otpRequired) {
            alert('OTP GENERATED SUCCESSFULLY');
            this.loginbox = false;
            this.showOtpBox = true;
          } else {
            // Handle other cases if needed
          }
        } else {
          this.utils.showErrorMsg(data.message);
          sessionStorage.clear();
          // alert('OTP GENERATION FAILED');
        }
      });
        }
      }
    }
      // this.AuthService.url.subscribe(data => {
      //   if (data.result === 'success') {
      //     localStorage.setItem('role', data.userType);
      //     sessionStorage.setItem('logoUrl', data.data.logoUrl);
      //     console.log('Logo URL stored:', data.logoUrl);
      //     this.router.navigateByUrl('/dashboard');
      //     if (data.otpRequired) {
      //       alert('OTP GENERATED SUCCESSFULLY');
      //       this.loginbox = false;
      //       this.showOtpBox = true;
      //     } else {
      //     }
      //   } else {
      //     this.utils.showErrorMsg(data.message)
      //     sessionStorage.clear()
      //     // alert('OTP GENERATION FAILED');
      //   }
      // });
      // this.storageService.clearStorage();

      // this.storageService.clearStorage();
      this.validateForm = this.fb.group({
        userName: ['', [Validators.required]],
        password: ['', [Validators.required]],
        //  otp: ['', [Validators.required]],
      });

      this.otpform = this.fb.group({
        userName: ['', [Validators.required]],
        password: ['', [Validators.required]],
        userOtp: ['', [Validators.required]],
      });
    }




    verifyotp() {

      this.AuthService.verifyOTP({...this.otpform.value,type:this.userType}).subscribe(data => {
        if (data.result === 'success') {
          sessionStorage.setItem('role',data.userType)

          // this.router.navigateByUrl('/dashboard')
          this.router.navigateByUrl('/dashboard');
          this.utils.showSuccessMsg(data.message)
        } else {
          this.utils.showErrorMsg(data.message)
        }

      });

    }
  }
